import axios from 'axios'
import {
  addContentTypeInterceptors,
  addErrorNormalizerInterceptor
} from '@repo/ui'

const api = axios.create({
  timeout: 30_000
})

addContentTypeInterceptors(api)
addErrorNormalizerInterceptor(api)

const setBaseUrl = (baseUrl: string) => {
  api.defaults.baseURL = baseUrl
}

export default api
export { setBaseUrl }
